var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import { trans } from '@/setup/locales';
let UnitPrice = class UnitPrice extends Vue {
    constructor() {
        super(...arguments);
        this.currentValue = 0;
        this.unitWeight = Infinity;
    }
    get price() {
        if (this.unitWeight === Infinity) {
            return trans('recipes.unit_weight_no_set');
        }
        if (this.unitWeight === 0) {
            return trans('recipes.unit_weight_no_zero');
        }
        return ((this.currentValue / this.unitWeight) * 1000.0).toFixed(2);
    }
    mounted() {
        const element = document.querySelector('#unit_weight');
        if (element) {
            element.addEventListener('keyup', event => {
                const target = event.currentTarget;
                this.updateUnitWeight(target.value);
            });
            this.updateUnitWeight(element.value);
            this.currentValue = this.value;
        }
    }
    updateUnitWeight(value) {
        const number = Number(value);
        if (value === '' || isNaN(number)) {
            this.unitWeight = Infinity;
        }
        else {
            this.unitWeight = number;
        }
    }
};
__decorate([
    Prop()
], UnitPrice.prototype, "position", void 0);
__decorate([
    Prop()
], UnitPrice.prototype, "id", void 0);
__decorate([
    Prop()
], UnitPrice.prototype, "value", void 0);
__decorate([
    Prop()
], UnitPrice.prototype, "name", void 0);
__decorate([
    Prop()
], UnitPrice.prototype, "priceWeight", void 0);
__decorate([
    Prop()
], UnitPrice.prototype, "priceUnit", void 0);
UnitPrice = __decorate([
    Component
], UnitPrice);
export default UnitPrice;
